import { render, staticRenderFns } from "./DashboardStudies.vue?vue&type=template&id=ec440714&scoped=true"
import script from "./DashboardStudies.vue?vue&type=script&lang=js"
export * from "./DashboardStudies.vue?vue&type=script&lang=js"
import style0 from "./DashboardStudies.vue?vue&type=style&index=0&id=ec440714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec440714",
  null
  
)

export default component.exports